export enum AgentTrainingSource {
  website = "website",
  text = "text",
  files = "files",
  questions = "questions",
}
